<div class="header-row" [formGroup]="headerGroup()">
  <input
    class="header-name-input"
    formControlName="name"
    type="text"
    placeholder="Header name"
    [ngClass]="{ 'input-form-invalid': isNameInvalid }"
  />
  <input
    class="header-value-input"
    formControlName="value"
    [type]="valueInputType()"
    [placeholder]="valuePlaceholder()"
    [ngClass]="{ 'input-form-invalid': isValueInvalid }"
  />
  <button type="button" class="header-remove-btn" (click)="onRemove()" matTooltip="Remove header">
    <img src="assets/images/common/delete.svg" alt="Remove" />
  </button>
</div>
